// extracted by mini-css-extract-plugin
export default {"list":"Consultation_list__PIXe5"};